import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.scss';
import { BrowserRouter } from 'react-router-dom';
import journalIcon40 from './asset/img/icons/journal-40.svg';
import journalIcon60 from './asset/img/icons/journal-60.svg';

[
	{ href: journalIcon40, sizes: '40x40' },
	{ href: journalIcon60, sizes: '60x60' },
].forEach(({ href, sizes }) => {
	const link = document.createElement('link');
	link.rel = 'icon';
	link.type = 'image/svg+xml';
	link.sizes = sizes;
	link.href = href;
	document.head.append(link);
});

const container: HTMLElement | null = document.getElementById('root');

if (container) {
	const root = createRoot(container);

	root.render(
		<BrowserRouter>
			<App />
		</BrowserRouter>,
	);
}
